// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".progress-screen[data-v-485d03a5]{align-items:center;background-color:#fff;display:flex;flex-direction:column;height:96vh;justify-content:center}.progress-bar-container[data-v-485d03a5]{text-align:center;width:500px}.progress-bar-container .v-progress-linear--rounded[data-v-485d03a5]{border-radius:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
